





















































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import DropArea from "../../components/DropArea.vue";
import { SumupGroup, Examinee, BaseAssessment } from "../../modules/teacher/PracticeSumupEdit"
import CustomConfirm from "../../components/CustomConfirmModal.vue";

export interface Data {
  sumup_group_id: string
  tabNo: number
  sumupGroup: SumupGroup
  examinees: Examinee[]
  is_exists_approval_sheet: boolean
  sheet_type_cache: number
  verify_count_cache: number
  curriculums: any[]
  errors: string[]
  isNew: boolean
  baseAssessments: BaseAssessment[]
  base_assessment_ids: number[]
  confirmMsg: string
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context){

    const confirmModalRef = ref<InstanceType<typeof CustomConfirm>>();

    const SheetTypeEnum = Common.SheetTypeEnum;

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: "",
      tabNo: 1,
      sumupGroup: new SumupGroup(),
      examinees: new Array<Examinee>(),
      is_exists_approval_sheet: false,
      sheet_type_cache: null,
      verify_count_cache: null,
      errors: new Array<string>(),
      curriculums: [],
      isNew: false,
      baseAssessments: [],
      base_assessment_ids: [],
      confirmMsg: null,
    });

    const addBaseAssessment = () => {
      state.baseAssessments.push(new BaseAssessment());
    }

    const deleteBaseAssessment = () => {
      state.baseAssessments.splice(state.baseAssessments.length - 1, 1);
    }

    /******************************
     * 名簿テンプレートダウンロード
     ******************************/

    const downloadMeiboTemplate = async () => {

      await http.get(`/api/teacher/practice_sumup_edit/download_meibo_template/${state.sumup_group_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `meibo_template.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /******************************
     * 名簿アップロードAPI
     ******************************/

    const uploadMeibo = async (file: any) => {
      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("受験者情報を読み込みます。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_edit/upload_meibo`, fd).then(response => {
        const examinees = new Array<Examinee>();
        response.data.examinees.forEach((examinee: any) => {
          examinees.push(new Examinee(examinee));
        });
        state.examinees = examinees
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 登録前のデータチェック
     ******************************/

    const validate = () => {
      state.errors = new Array<string>();
      if (!state.sumupGroup.nendo) {
        state.errors.push("年度が入力されていません。");
      }
      if (!state.sumupGroup.exec_times) {
        state.errors.push("回次が入力されていません。");
      }
      if (!state.sumupGroup.exec_date) {
        state.errors.push("実施日が入力されていません。");
      }
      if (!state.sumupGroup.name) {
        state.errors.push("試験名が入力されていません。");
      }
      if(!state.sumupGroup.sheet_type){
        state.errors.push("採点方法が入力されていません。");
      }
      if(state.sumupGroup.sheet_type == SheetTypeEnum.Practice && !state.sumupGroup.verify_count){
        state.errors.push("採点回数が選択されていません");
      }
      if(state.baseAssessments.length == 1){
        state.errors.push("判定を登録する場合、最低でも2行登録してください。");
      }
      if(state.baseAssessments.filter(x => x.name == "").length > 0){
        state.errors.push("判定名が入力されていません。");
      }
      if (state.examinees.length == 0) {
        state.errors.push("受験者情報エクセルが読み込まれていません。");
      }

      return state.errors.length == 0;
    };

    /******************************
     * 新規登録API
     ******************************/

    const createClick = async () => {
      if (!validate() || !window.confirm('データを登録します。よろしいですか？')) {
        return;
      }

      // コンペア採点の場合、ベリファイ数は1固定で登録
      if(state.sumupGroup.sheet_type == SheetTypeEnum.PracticeCompare){
        state.sumupGroup.verify_count = 1;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_edit`, {sumup_group: state.sumupGroup, examinees: state.examinees, base_assessments: state.baseAssessments}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 更新ボタンクリック
     ******************************/

    const updateClick = async () => {

      if(state.sheet_type_cache != state.sumupGroup.sheet_type){
        
        await http.get(`/api/teacher/practice_sumup_edit/is_exists_uploaded_sheet/${state.sumup_group_id}`).then(async response => {
          if(response.data.is_exists_uploaded_sheet){
            state.errors.push("答案アップロード済みの模試では採点方法の変更はできません。変更する場合は答案を削除してください。");
          }else{
            if(window.confirm('データをを更新します。よろしいですか？')){
              await update(false);
            }
          }
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }else if(state.is_exists_approval_sheet && state.sumupGroup.sheet_type == SheetTypeEnum.Practice && state.verify_count_cache < state.sumupGroup.verify_count){
        state.confirmMsg = '承認済みの試験が存在します。採点回数を増やすと、承認済みの試験は未承認に戻り、生徒に成績公開済みの場合は未公開に戻ります。よろしいですか？';
        confirmModalRef.value.show();
      }else if(window.confirm('データをを更新します。よろしいですか？')){
        await update(false);
      }
    }

    /******************************
     * 更新API
     ******************************/

    const update = async (is_reset_approval_flg: boolean) => {

      confirmModalRef.value.hide();

      if(!validate()){
        return;
      }

      const isDeleteAssessment = state.baseAssessments.length != state.base_assessment_ids.length;

      if(isDeleteAssessment && state.base_assessment_ids.length > 0){
        if (!window.confirm('判定区分の件数が変更されています。更新を実行すると登録済みの判定情報、集計済みの判定結果は削除されます。よろしいですか？')) {
          return;
        }
      }else{
        state.baseAssessments.forEach((x, i) => x.id = state.base_assessment_ids[i]);
      }

      // コンペア採点の場合、ベリファイ数は1固定で登録
      if(state.sumupGroup.sheet_type == SheetTypeEnum.PracticeCompare){
        state.sumupGroup.verify_count = 1;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_edit/update/${state.sumup_group_id}`, {sumup_group: state.sumupGroup, examinees: state.examinees, is_reset_approval_flg: is_reset_approval_flg, base_assessments: state.baseAssessments}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 削除API
     ******************************/

    const deleteClick = async () => {
      if(!window.confirm("試験を削除します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/practice_sumup_edit/${state.sumup_group_id}`).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.isNew = context.root.$route.path.indexOf("new") != -1;
      
      // 受験可能教科取得
      state.curriculums = context.root.$store.state.curriculums.filter((x: any) => x.id <= 5);

      if(!state.isNew){
        await http.get(`/api/teacher/practice_sumup_edit/?sumup_group_id=${state.sumup_group_id}`).then(response => {
          state.sumupGroup.exec_date = moment(response.data.sumup_group.exec_date).format('YYYY-MM-DD');
          state.sumupGroup.name = response.data.sumup_group.name;
          state.sumupGroup.sheet_type = response.data.sheet_type;
          state.sumupGroup.verify_count = response.data.verify_count;
          state.is_exists_approval_sheet = response.data.is_exists_approval_sheet;
          state.sheet_type_cache = response.data.sheet_type;
          state.verify_count_cache = response.data.verify_count;
          state.sumupGroup.is_sort_answer_image_enable = response.data.is_sort_answer_image_enable;
          state.sumupGroup.is_mask_student_info = response.data.is_mask_student_info;
          state.sumupGroup.is_print_part1 = response.data.is_print_part1;
          state.sumupGroup.is_use_mark_recog_field = response.data.is_use_mark_recog_field;
          state.sumupGroup.is_use_hosei = response.data.is_use_hosei;
          state.sumupGroup.exec_times = response.data.sumup_group.exec_times;
          state.sumupGroup.nendo = response.data.sumup_group.nendo;
          state.baseAssessments = response.data.base_assessments.map((x: any) => new BaseAssessment(x));
          state.base_assessment_ids = state.baseAssessments.map(x => x.id);
          
          response.data.examinees.forEach((examinee: any) => {
            state.examinees.push(new Examinee(examinee));
          });
        })
        .catch(error=>{
          // 後続処理不能のため一覧に戻る
          if(error.response.status == 422){
            alert(`処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
          }else{
            alert(`処理に失敗しました。一覧に戻ります。`);
          }
          window.history.back();
        });
      }
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      confirmModalRef,
      SheetTypeEnum,
      createClick,
      updateClick,
      update,
      deleteClick,
      uploadMeibo,
      downloadMeiboTemplate,
      addBaseAssessment,
      deleteBaseAssessment
    };
  }
})
